import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { Spinner, Alert } from '@grandvisionhq/iris-ui';
import { useIntl, useDispatch } from '@grandvisionhq/state';
import { appointmentsView } from '../../data-layer/appointments/actions.js';
import { useAppointments } from '../hooks/useAppointments.js';
import AppointmentBody from './components/AppointmentBody/AppointmentBody.js';

const AppointmentsContainer = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const dispatch = useDispatch();
    const { data: appointments , loading , error  } = useAppointments();
    const routeLabel = getLabel(`account.menu.appointments`);
    React.useEffect(()=>{
        if (loading || appointments === null) {
            return;
        }
        dispatch(appointmentsView(appointments));
    }, [
        appointments,
        dispatch,
        loading
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small"
    }, routeLabel), loading ? /*#__PURE__*/ React.createElement(Spinner, {
        "aria-label": getLabel('common.loadingText')
    }) : error || appointments === null ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "error",
        className: "alert-m-default"
    }, getFormattedLabel('common.error.network')) : // not loading and no error
    /*#__PURE__*/ React.createElement(AppointmentBody, {
        appointments: appointments
    }));
};

export { AppointmentsContainer as default };
//# sourceMappingURL=Appointments.js.map
